var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-100 display-flex flex-row"},_vm._l((_vm.panels),function(panel,i){return _c('InstallationWizardTab',_vm._g({key:panel.title,attrs:{"tabIndex":i,"panels":_vm.panels,"openedPanelIndex":_vm.openedPanelIndex,"notValidConfigurationsIds":_vm.notValidConfigurationsIds}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }